// extracted by mini-css-extract-plugin
module.exports = {"root":"SGSTooltip_root__Hh-ik","tooltip":"SGSTooltip_tooltip__1wkKw","pointer":"SGSTooltip_pointer__3cFMI","content":"SGSTooltip_content__2_yRV"};